<template>
    <div class="d-inline-block">
        <div class="dropdown">
            <button
                class="btn btn-primary"
                type="button"
                @click="showImportModal">
                Import Translations
            </button>
        </div>
        <div class="modal fade import-translations-modal" id="import-translations-modal" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body align-content-center">
                        <fieldset class="form-group tasks-started">
                            <legend class="close-modal d-flex justify-content-between">
                                <strong>Import Translations</strong>
                                <div class="justify-content-end">
                                    <button class="btn close close-modal" data-dismiss="modal">
                                        <ion-icon name="close"></ion-icon>
                                    </button>
                                </div>
                            </legend>
                        </fieldset>
                        <form @submit.prevent.stop="onSubmit" ref="form">
                            <div class="row">
                                <div class="col-12">
                                    <app-select
                                        label="Language"
                                        :error="languageError"
                                        placeholder="Language"
                                        name="language_id"
                                        id="filter-type"
                                        :is-multiple="false"
                                        :use-search="false"
                                        :options="languages"
                                        @input="selectLanguage"
                                        :is-required="true"
                                    ></app-select>
                                </div>
                                <div class="form-group d-inline-flex col-12 mt-3">
                                    <label class="input-label mr-3 w-25">File (*.csv)</label>
                                    <div class="d-flex w-75">
                                        <div>
                                            <input
                                                id="file"
                                                name="file"
                                                type="file"
                                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                :required="true"
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer clearfix d-flex p-0">
                                <p class="w-100">Example</p>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                source
                                            </th>
                                            <th>
                                                component
                                            </th>
                                            <th>
                                                translation
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                test_source
                                            </td>
                                            <td>
                                                test_component
                                            </td>
                                            <td>
                                                test_translation
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ...
                                            </td>
                                            <td>
                                                ...
                                            </td>
                                            <td>
                                                ...
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p>
                                    <b>Important for delete!</b>
                                    If there are no translation and component fields in the file then the source will be deleted.
                                </p>
                            </div>
                            <div class="modal-footer clearfix d-flex justify-content-end">
                                <button class="btn btn-danger mt-2" :disabled="this.loading">
                                    <ion-icon name="play" class="mb--1"></ion-icon> Run
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <loading-overlay :loading="loading"></loading-overlay>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            languages: {
                type: Array,
                default: []
            },
            dataBase: {
                type: String,
            },
        },
        data() {
            return {
                selectedLanguage: {},
                languageError: '',
                file: '',
                loading: false,
            }
        },
        methods: {
            showImportModal() {
                $('#import-translations-modal').modal('show');
            },
            hideModal() {
                $('#import-translations-modal').modal('hide');
                this.file = '';
                this.languageError = '';
                this.selectedLanguage = {};
            },
            selectLanguage(language_id) {
                this.selectedLanguage = this.languages.find((lang) => {
                    if (lang.id == language_id) {
                        return true;
                    }
                });
            },
            onSubmit() {
                if (this.selectedLanguage.id !== undefined) {
                    this.loading = true;
                    let formData = new FormData(this.$refs.form);
                    formData.append('db', this.dataBase);

                    axios({
                        method: 'post',
                        url: this.route('run-import'),
                        data: formData,
                        headers: {'Content-Type': 'multipart/form-data'},
                    }).then(() => {
                        this.$notifications.success('Translations was imported.');
                        this.loading = false;
                        this.hideModal();
                        document.location.href = this.route('translations.index', {'db' : this.dataBase});
                    })
                    .catch(() => {
                        this.loading = false;
                        this.hideModal();
                        this.$notifications.error('Something happens.');
                    });
                } else {
                    this.languageError = 'Language is required';
                }
            },
        }
    }

</script>

<style scoped lang="scss">
button.btn-primary {
    color: #fff;
    background-color: #0060D6;
    font-weight: 500;
}

button.btn-primary:hover {
    color: #fff;
    background-color: #0060D6;
    font-weight: 500;
}
div.run-connection-modal {
    button.btn.close.close-modal {
        top: -40px;
        position: relative;
    }

    legend.close-modal {
        max-height: 25px;
    }

    .modal-footer {
        padding: 0;
    }

    .modal-footer > * {
        margin: 0;
    }
}

#import-translations-modal .modal-dialog {
    position: relative;
}
</style>
